import * as req from 'api/actions';
import * as c from './constant';

export const getFireSafetyCalculation = (payload, callback) =>
  req.list(
    c.GET_FIRE_SAFETY_CALCULATION,
    `/api/v1/bpls/administrator/tax_revenue/fsis_calculation_fire_safeties`,
    payload,
    callback
  );

export const getFireSafetyList = (payload, callback) =>
  req.list(
    c.GET_FIRE_SAFETY_LIST,
    `/api/v1/bpls/administrator/common/fee_codes`,
    payload,
    // callback,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    }
  );

export const updateCalculationFireSafety = (payload, callback) =>
  req.create(
    c.UPDATE_CALCULATION_FIRE_SAFETY,
    `/api/v1/bpls/administrator/tax_revenue/fsis_calculation_fire_safeties`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getFireSafetySettings = (payload, callback) =>
  req.item(
    c.GET_FIRE_SAFETY_SETTINGS,
    `/api/v1/bpls/administrator/fire_safety_settings`,
    payload,
    callback
  );

export const updateFireSafetySettings = (payload, callback) =>
  req.update(
    c.UPDATE_FIRE_SAFETY_SETTINGS,
    `/api/v1/bpls/administrator/fire_safety_settings`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );